'use client';
import '../button/button.js';
import { ButtonSize } from '../button/constants.js';

var HeaderEntryTextColor;
(function (HeaderEntryTextColor) {
    HeaderEntryTextColor["DEFAULT"] = "DEFAULT";
    HeaderEntryTextColor["RED"] = "RED";
})(HeaderEntryTextColor || (HeaderEntryTextColor = {}));
const HeaderEntryTextColorMap = {
    [HeaderEntryTextColor.DEFAULT]: 'text-leland-gray-dark',
    [HeaderEntryTextColor.RED]: 'text-leland-red',
};
function isHeaderLink(entry) {
    return 'url' in entry;
}
function isHeaderButton(entry) {
    return 'onClick' in entry;
}
function isHeaderNestedNav(entry) {
    return 'childEntries' in entry;
}
// Note: this is a workaround to update the font size of the button without changing the Button component props
const HeaderEntryFontSizeClass = {
    [ButtonSize.SMALL]: '[&_button]:!text-base [&_button]:!leading-none',
    [ButtonSize.MEDIUM]: '[&_button]:!text-lg [&_button]:!leading-tight',
    [ButtonSize.LARGE]: '[&_button]:!text-lg [&_button]:!leading-tight',
};

export { HeaderEntryFontSizeClass, HeaderEntryTextColor, HeaderEntryTextColorMap, isHeaderButton, isHeaderLink, isHeaderNestedNav };
//# sourceMappingURL=header-entry.js.map
